<template>
  <div>
    <el-dialog
      title="公司/部门"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="55%"
      @close="closeDialog"
    >
      <el-tree
        ref="tree"
        :data="data"
        :props="defaultProps"
        show-checkbox
        :expand-on-click-node="false"
        default-expand-all
        highlight-current
        node-key="value"
        :default-checked-keys="chkVals"
        :style="{ height: heightTree, overflow: 'auto' }"
      />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm()">{{ $t('dialog.confirm') }}</el-button>
        <el-button @click="closeDialog()">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import { mapState } from 'vuex';
  export default {
    components: {},
    data() {
      return {
        dialogVisible: false,
        defaultProps: {
          children: 'children',
          label: function (data) {
            return data.label;
          },
        },
        chkVals: [],
        data: [],
      };
    },
    mounted() {},
    computed: {
      heightTree() {
        return window.innerHeight - 370 + 'px';
      },
    },
    methods: {
      openDialog(chkVals, data) {
        this.dialogVisible = true;
        this.chkVals = chkVals;
        this.data = data;
      },
      closeDialog() {
        this.dialogVisible = false;
        this.chkVals = [];
      },
      confirm() {
        let chkNodes = [];
        this.$refs.tree.getCheckedNodes().map((item) => {
          if (item.companyCode && !item.disabled) {
            chkNodes.push(item);
          }
        });
        if (chkNodes.length == 0) {
          return this.$message({ showClose: true, message: '您还未选择任何部门！', type: 'error' });
        }
        this.$emit('confirm', chkNodes);
        this.closeDialog();
      },
    },
  };
</script>

<style></style>
